const Menu = [
    {
        path: '/home/about',
        title: '카라교육',
        children: [
            { path: '/home/about', title: '동물권 교육' },
            //{ path: '/home/history', title: '연혁' },
            { path: '/home/field', title: '교육현장과 동물' }
        ]
    },
    {
        path: '/activity/visit',
        title: '교육활동',
        children: [
            { path: '/activity/visit', title: '교육소식' },
            //{ path: '/activity/learn', title: '더배움' },
            //{ path: '/activity/rental', title: '교구대여' },
            { path: '/activity/calendar', title: '교육일정' }
        ]
    },
    /*{
        path: '/cinema/article',
        title: '동물영화제',
        children: [
            //{ path: '/cinema/guide', title: '영화제 소개' },
            { path: '/cinema/article', title: '영화제 소식' },
            { path: '/cinema/scene', title: '현장 스케치' }
        ]
    },*/
    {
        path: '/library/intro',
        title: '킁킁도서관',
        children: [
            { path: '/library/intro', title: '도서관 소개' },
            { path: '/library/search', title: '자료 검색' },
            { path: '/library/news', title: '도서관 소식' },
            //{ path: '/library/day', title: '사서냥이의 하루' }
        ]
    },
    {
        path: '/report/newsletter',
        title: '자료실',
        children: [
            { path: '/report/newsletter', title: '뉴스레터' },
            //{ path: '/details/report/newsletter/' + latestNewsletter(0), title: '뉴스레터' },
            { path: '/report/sniffleader', title: '킁킁리더' },
            { path: '/report/resource', title: '교육자료' },
        ]
    },

]

export default Menu;



// WEBPACK FOOTER //
// ./src/components/front/header/menu.js